export * from "./LoggedUser.model";
export * from "./User.model";
export * from "./Gate.model";

export const API_URL = 'https://7hl2101419.execute-api.us-east-1.amazonaws.com';
// export const API_URL = 'http://localhost:3000';